import { render } from "./MainTeacher.vue?vue&type=template&id=6896b1ae&ts=true"
import script from "./MainTeacher.vue?vue&type=script&lang=ts"
export * from "./MainTeacher.vue?vue&type=script&lang=ts"

import "./MainTeacher.vue?vue&type=style&index=0&id=6896b1ae&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__